import styles from '@/scopes/checkout/components/Layout/styles.module.css'
import * as React from 'react'

export function ContentCentered({ children }: React.PropsWithChildren) {
  return (
    <div
      className={
        styles.centeredContent
      }
    >
      {children}
    </div>
  )
}
